import React, { useState } from 'react';
import { Star, ChevronLeft, ChevronRight } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
const testimonials = [{
  quote: 'Organicé toda mi intervención domiciliaria en un fin de semana. Ahora sé exactamente qué hacer en cada visita con cada paciente. Nunca más llego al domicilio improvisando.',
  name: 'Luciana M.',
  location: 'Buenos Aires',
  role: 'Terapista Ocupacional domiciliaria independiente',
  initial: 'L'
}, {
  quote: 'Los protocolos de AVD por nivel cambiaron todo. En 6 semanas mi paciente con Parkinson moderado recuperó independencia en el baño y el vestido. Resultados que la familia no esperaba ver tan rápido.',
  name: 'Sebastián R.',
  location: 'Rosario',
  role: 'TO especializado en neurología',
  initial: 'S'
}, {
  quote: 'Adapto la sesión al estado del paciente en 5 minutos mirando la planilla. Antes me llevaba horas buscar recursos en internet para armar algo coherente para cada visita.',
  name: 'Valentina F.',
  location: 'Córdoba',
  role: 'Terapista Ocupacional domiciliaria en PAMI',
  initial: 'V'
}, {
  quote: 'Las plantillas de informe para PAMI me ahorran horas cada mes. Pasé tres auditorías sin una sola observación. La documentación profesional cambia por completo cómo te ve la obra social.',
  name: 'Carolina P.',
  location: 'La Plata',
  role: 'TO con cartera PAMI activa',
  initial: 'C'
}, {
  quote: 'El tomo de comunicación familiar fue oro puro. Tenía un caso con una hija sobreprotectora que bloqueaba cada intervención. Con los guiones del kit logré transformarla en aliada terapéutica.',
  name: 'Martín D.',
  location: 'Mendoza',
  role: 'Terapista Ocupacional domiciliario',
  initial: 'M'
}, {
  quote: 'Soy recién recibida y me sentía perdida en el domicilio. Este sistema me dio la estructura que la facultad no me dio. Hoy mis pacientes y sus familias me ven como una profesional con autoridad clínica.',
  name: 'Agustina B.',
  location: 'Tucumán',
  role: 'TO recién graduada · primer año domicilio',
  initial: 'A'
}, {
  quote: 'Las adaptaciones del entorno son simples pero efectivas. Mi paciente con Parkinson avanzado dejó de caerse en el baño desde la primera semana. La familia me considera parte del equipo ahora.',
  name: 'Federico T.',
  location: 'Mar del Plata',
  role: 'TO en abordaje neurodegenerativo',
  initial: 'F'
}];
export const Testimonials = () => {
  const [active, setActive] = useState(0);
  const next = () => setActive(p => (p + 1) % testimonials.length);
  const prev = () => setActive(p => (p - 1 + testimonials.length) % testimonials.length);
  return <section className="py-10 md:py-16 bg-cream" data-id="element-364">
      <div className="max-w-6xl mx-auto px-4" data-id="element-365">
        {/* Mobile: Swipeable carousel */}
        <div className="md:hidden" data-id="element-366">
          <div className="relative bg-white p-6 rounded-2xl shadow-sm border border-gray-100 min-h-[280px]" data-id="element-367">
            <AnimatePresence mode="wait" data-id="element-368">
              <motion.div key={active} initial={{
              opacity: 0,
              x: 20
            }} animate={{
              opacity: 1,
              x: 0
            }} exit={{
              opacity: 0,
              x: -20
            }} transition={{
              duration: 0.3
            }} className="flex flex-col h-full" data-id="element-369">
                <div className="flex items-center gap-3 mb-4" data-id="element-370">
                  <div className="w-12 h-12 rounded-full bg-teal text-white flex items-center justify-center font-bold text-lg flex-shrink-0" data-id="element-371">
                    {testimonials[active].initial}
                  </div>
                  <div className="flex-grow" data-id="element-372">
                    <p className="font-bold text-navy text-sm" data-id="element-373">
                      {testimonials[active].name} —{' '}
                      {testimonials[active].location}
                    </p>
                    <p className="text-xs text-gray-500" data-id="element-374">
                      {testimonials[active].role}
                    </p>
                  </div>
                </div>
                <div className="flex text-gold mb-3" data-id="element-375">
                  {[...Array(5)].map((_, j) => <Star key={j} className="w-4 h-4 fill-current" data-id="element-376" />)}
                </div>
                <p className="text-gray-700 italic text-sm leading-relaxed" data-id="element-377">
                  "{testimonials[active].quote}"
                </p>
              </motion.div>
            </AnimatePresence>
          </div>
          <div className="flex items-center justify-between mt-4" data-id="element-378">
            <button onClick={prev} aria-label="Anterior" className="bg-white p-2 rounded-full shadow-sm border border-gray-200 active:scale-95" data-id="element-379">
              <ChevronLeft className="w-5 h-5 text-navy" data-id="element-380" />
            </button>
            <div className="flex gap-2" data-id="element-381">
              {testimonials.map((_, i) => <button key={i} onClick={() => setActive(i)} aria-label={`Ir al testimonio ${i + 1}`} className={`h-2 rounded-full transition-all ${active === i ? 'w-8 bg-teal' : 'w-2 bg-gray-300'}`} data-id="element-382" />)}
            </div>
            <button onClick={next} aria-label="Siguiente" className="bg-white p-2 rounded-full shadow-sm border border-gray-200 active:scale-95" data-id="element-383">
              <ChevronRight className="w-5 h-5 text-navy" data-id="element-384" />
            </button>
          </div>
        </div>

        {/* Desktop: 3-col grid */}
        <div className="hidden md:grid grid-cols-3 gap-8" data-id="element-385">
          {testimonials.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="bg-white p-8 rounded-2xl shadow-sm border border-gray-100 flex flex-col h-full hover:shadow-md transition-shadow" data-id="element-386">
              <div className="flex text-gold mb-4" data-id="element-387">
                {[...Array(5)].map((_, j) => <Star key={j} className="w-5 h-5 fill-current" data-id="element-388" />)}
              </div>
              <p className="text-gray-700 italic mb-6 flex-grow" data-id="element-389">"{t.quote}"</p>
              <div className="flex items-center gap-3 pt-4 border-t border-gray-100" data-id="element-390">
                <div className="w-10 h-10 rounded-full bg-teal text-white flex items-center justify-center font-bold" data-id="element-391">
                  {t.initial}
                </div>
                <div data-id="element-392">
                  <p className="font-bold text-navy text-sm" data-id="element-393">
                    {t.name} — {t.location}
                  </p>
                  <p className="text-xs text-gray-500" data-id="element-394">{t.role}</p>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
};